import { CommonProperties } from '../BookingsCalendarTypes';

export function filterBasedOnProductProperties(selectedProperties) {
    return function filter(photographer) {
        const photographerProducts = photographer.availableForProducts;
        for (const product in photographerProducts) {
            if (!photographerProducts[product]) {
                if (selectedProperties.includes(CommonProperties[product])) {
                    return false;
                }
            }
        }
        return true;
    };
}
